"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListboxOptionLabel = void 0;
var _ListboxOptionLabel = require("./ListboxOptionLabel");
// TODO: in v9, move styled() from ListboxOptionLabel.jsx to here
var StyledListboxOptionLabel = _ListboxOptionLabel.ListboxOptionLabel;
exports.StyledListboxOptionLabel = StyledListboxOptionLabel;